import { render, staticRenderFns } from "./send-dialog.vue?vue&type=template&id=7fa9be7a&scoped=true&"
import script from "./send-dialog.vue?vue&type=script&lang=js&"
export * from "./send-dialog.vue?vue&type=script&lang=js&"
import style0 from "./send-dialog.vue?vue&type=style&index=0&id=7fa9be7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa9be7a",
  null
  
)

export default component.exports